// src/pages/CapitalBalance/components/exportCapitalBalanceCsv.js

const fmt = (num) =>
  Number(num || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const escape = (val) => {
  const str = String(val ?? "");
  return str.includes(",") || str.includes('"') || str.includes("\n")
    ? `"${str.replace(/"/g, '""')}"`
    : str;
};

/**
 * @param {object} params
 * @param {Array}   params.list         - from Redux state.capitalBalance.list
 * @param {number}  params.balanceTotal - from Redux state.capitalBalance.balanceTotal
 * @param {string}  params.title
 * @param {string}  params.filename
 */
export const exportCapitalBalanceCsv = ({
  list,
  balanceTotal,
  title    = "Capital Balance Report",
  filename = "capital_balance",
}) => {
  const headers = [
    "No.", "Account Name", "Opening Balance",
    "Debit Amount", "Credit Amount", "Balance",
  ].map(escape);

  const dataRows = list.map((row, i) => [
    i + 1,
    row.acc_name        || "",
    fmt(row.opening_balance),
    fmt(row.received_total),
    fmt(row.investment_total),
    fmt(row.balance),
  ].map(escape));

  const openingTotal = list.reduce((s, r) => s + Number(r.opening_balance  || 0), 0);
  const debitTotal   = list.reduce((s, r) => s + Number(r.received_total   || 0), 0);
  const creditTotal  = list.reduce((s, r) => s + Number(r.investment_total || 0), 0);

  const totalRow = [
    "Grand Total:", "",
    fmt(openingTotal),
    fmt(debitTotal),
    fmt(creditTotal),
    fmt(balanceTotal),   // 👈 uses Redux-provided total (matches table behaviour)
  ].map(escape);

  const rows = [[title], [], headers, ...dataRows, [], totalRow];

  const csv  = rows.map((r) => r.join(",")).join("\n");
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement("a");
  a.href     = url;
  a.download = `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};